import { COLORS, SPACING } from '@alto/design-library-tokens';
import { ActionSheetContext, Description, InputSelect, LgPadding, Link, Row, XsSpacing } from '@alto/design-system';
import {
  type FertilityCycleMedicationType,
  FertilityCycleMedicationTypeMap,
} from '@alto/scriptdash/alto/fertility_cycles/types/v1/fertility_cycle_medication_type';
import React, { useContext } from 'react';
import { CETROTIDE_FIRST_FILL_DAYS_SUPPLY_OPTIONS, DAYS_SUPPLY_OPTIONS, MEDICATION_TYPES_DISPLAY } from '../constants';
import { CalculationInfoActionSheet } from './CalculationInfoActionSheet';

type Props = {
  readonly medicationType: FertilityCycleMedicationType;
  readonly firstFill: boolean | null | undefined;
  readonly value: string;
  readonly onChange: (value: string) => void;
};

export const LeftoverMedInput = ({ medicationType, firstFill, value, onChange }: Props) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);

  const handleShowCalculationHelp = (medicationType: FertilityCycleMedicationType) => {
    setActiveActionSheet(<CalculationInfoActionSheet medicationType={medicationType} />);
  };

  return (
    <LgPadding
      topPadding={SPACING.STATIC.MD}
      bottomPadding={SPACING.STATIC.MD}
    >
      <Row spaceBetween>
        <Description
          color={COLORS.TEXT_COLORS.PRIMARY}
          fontFamily="semibold"
        >
          {MEDICATION_TYPES_DISPLAY[medicationType]}
          <Description color={COLORS.TEXT_COLORS.DANGER}> *</Description>
        </Description>
        <Link
          textSize="mini"
          onPress={() => {
            handleShowCalculationHelp(medicationType);
          }}
        >
          Help me calculate
        </Link>
      </Row>
      <XsSpacing />
      <InputSelect
        onValueChange={onChange}
        value={value}
        placeholder="Select amount on hand..."
        options={
          firstFill && medicationType === FertilityCycleMedicationTypeMap.CETROTIDE
            ? CETROTIDE_FIRST_FILL_DAYS_SUPPLY_OPTIONS
            : DAYS_SUPPLY_OPTIONS
        }
        modalTitle={firstFill ? 'Select number of days leftover' : 'Select number of days on hand'}
      />
    </LgPadding>
  );
};
